export default __webpack_public_path__ + "static/media/minicard4.7e6affe1.jpg";